import React from "react";
import styles from "./SubscriptionPlansContainer.module.scss";

const SubscriptionPlansContainer = ({ children, className = "" }) => {
    return (
        <div className={`${styles.plansContainer} ${className}`}>
            {children}
        </div>
    );
};

export default SubscriptionPlansContainer;
